import { defineMessages } from 'react-intl-next';

export const messages: {
	dynamic_layout_list_project_status_merged: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dynamic_layout_list_see_more: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dynamic_layout_list_see_less: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	dynamic_layout_list_project_status_merged: {
		id: 'search_ai.dynamic_layout_list_project_status_merged',
		defaultMessage: 'Merged',
		description: 'Merged text used in lozange',
	},
	dynamic_layout_list_see_more: {
		id: 'search_ai.dynamic_layout_list_see_more',
		defaultMessage: 'See more',
		description: 'Text to expand list',
	},
	dynamic_layout_list_see_less: {
		id: 'search_ai.dynamic_layout_list_see_less',
		defaultMessage: 'See less',
		description: 'Text to collapse list',
	},
});
